import styled from '@emotion/styled';
import { mq } from '../../../styles/mixins';
import { css } from '@emotion/react';
import { THEME } from 'common/consts/theme';

export const ProcessTimelineWrapper = styled.div`
  background: ${({ theme }) => theme.colors.core_white};
  box-shadow: 0.5rem 0.5rem 1.5rem rgba(23, 0, 89, 0.29);
  border-radius: 0.5rem;
  position: relative;
  padding: 2rem;

  width: min(80vw, 1170px);
  margin: 0 auto;

  ${mq.xSmall(css`
    bottom: -300px;
    margin: -300px auto 0;
    padding-bottom: 2.5rem;
  `)}

  ${mq.medium(css`
    bottom: -300px;
    margin: -300px auto 0;
    padding-bottom: 64px;
  `)}

  ${mq.large(css`
    margin: -200px auto 0;
    bottom: -200px;
    padding-bottom: 5rem;
  `)}
`;

export const Title = styled.p`
  font: normal normal 1.5rem/2rem ${({ theme }) => theme.font.questrial},
    sans-serif;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 0 0 2rem 0;

  ${mq.medium(css`
    font: normal normal 2rem/2.5rem ${THEME.font.questrial}, sans-serif;
    margin-bottom: 4rem;
  `)}
`;

export const TimelineImage = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const TimelineVideo = styled.div`
  width: 100%;
  height: 100%;

  video {
    width: 100%;
  }
`;
